const CourseCheckoutError = {
  COURSE_ALREADY_BOUGHT: 'ALREADY_BOUGHT',
  SWISH_INVALID_PHONE: 'BE18',
  SWISH_PAYMENT_ALREADY_IN_PROGRESS: 'RP06',
  SWISH_COUNTERPART_NOT_ACTIVATED: 'ACMT01',
  SWISH_PAYER_NOT_ENROLLED: 'ACMT03',
  SWISH_TRANSACTION_DECLINED: 'RF07',
  SWISH_BANKID_CANCELED: 'BANKIDCL',
  SWISH_PAYMENT_REQUEST_EXPIRED: 'TM01',
  SWISH_BANK_SYSTEM_PROCESSING_ERROR: 'FF10',
  SWISH_TIMED_OUT_WAITING_FOR_BANK: 'DS24',
};
export default CourseCheckoutError;
